import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const ROLE_CREATE_TASK: BuiltInTaskDefinition = {
    slug: 'role-create',
    name: 'Create a role from a conversation',
    kind: 'llm',
    overlapPolicy: 'skip',
    concurrencySafe: true,
    serializeOn: null,
    builtInRole: 'org_change',
    chatPurpose: null,
    goal: 'Turn what the CEO describes into a ready-to-apply role definition, write it as a plan, and get their sign-off; the OS creates the role at their approval',
    metric: {
        text: 'Share of role-creation conversations that reach CEO sign-off without a human re-explaining the request',
    },
    guardrails: [
        'Propose only — write the plan with os.write_plan; the OS creates the role once the CEO approves',
        'Reuse an existing role before proposing a new one that overlaps it',
        'A request spanning more than one entity proposes the whole flow as one plan',
    ],
    inputs: [
        {
            key: 'request',
            label: 'What the CEO wants',
            type: 'string',
            required: true,
        },
        {
            key: 'ceoNote',
            label: 'CEO note from a previous round',
            type: 'string',
            required: false,
        },
        {
            key: 'chatSessionId',
            label: 'Chat session this plan belongs to (chat fills it)',
            type: 'string',
            required: false,
        },
        {
            key: 'planKey',
            label: 'The conversation this plan belongs to when it has no chat session (the OS fills it)',
            type: 'string',
            required: false,
        },
    ],
    tools: ['os.directory', 'os.write_plan', 'os.read_plan', 'os.ask_ceo'],
    gates: [
        {
            tool: 'os.ask_ceo',
            owner: 'ceo',
            approval: 'specific',
        },
    ],
    spend: {
        moneyUsdPerRun: 1.5,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'role-create',
            on: 'ceo_approved',
            resumeConversation: true,
        },
        {
            slug: 'role-create',
            on: 'ceo_changes_requested',
        },
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    skillMd: TASK_TEXT['role-create.md'],
    adapterMd: TASK_TEXT['role-create.adapter.md'],
}
